import { $nav } from './context.js'

/* global Swiper */

/** @type {import('swiper').default | null} */
let productSwiper = null

/**
 * Inicializa el swiper de navegación de productos.
 */
export const initProductSwiper = () => {
    const slides = Array.from(document.querySelectorAll('.product-swiper .swiper-slide'))
    const activeLink = $nav.find('.product-link.is-active')
    const activeId = activeLink?.data('product-id')
    const activeSlide = activeId
        ? slides.find((slideElement) => slideElement.getAttribute('data-product-id') === activeId)
        : null

    productSwiper = new Swiper('.product-swiper', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        slideToClickedSlide: true,
        grabCursor: true,
        allowTouchMove: true,
        initialSlide: activeSlide ? slides.indexOf(activeSlide) : 0
    })
}

/**
 * Desliza el swiper hasta el slide cuyo data-product-id coincide.
 * @param {string} id
 * @param {number} speed
 */
const slideToProduct = (id, speed) => {
    if (!productSwiper) return
    const index = productSwiper.slides.findIndex(
        (slideEl) => slideEl.getAttribute('data-product-id') === id
    )
    if (index > -1) productSwiper.slideTo(index, speed)
}

/**
 * Marca el enlace del producto cuya URL coincide como activo y desliza el swiper.
 * Los demás enlaces pierden el estado activo.
 * @param {string} url
 */
export const setActiveProduct = (url) => {
    $nav.findAll('.product-link')?.forEach((link) => {
        if (link.attr('href') === url) {
            link.addClass('is-active').attr('aria-current', 'page')
            const id = link.data('product-id')
            if (id) slideToProduct(id, 300)
        } else {
            link.removeClass('is-active')
            link.removeAttr('aria-current')
        }
    })
}
